import ActionTypes from '../constants/ActionTypes';

export const handleSocketDisconnect = () => ({
  type: ActionTypes.SOCKET_DISCONNECT_HANDLE,
  payload: {},
});

export const handleSocketReconnect = (
  user,
  group,
  users,
  businesses,
  businessManagers,
  countries,
  brands,
  accounts,
  customerGroups,
  groups,
  groupMemberships,
  labels,
  customers,
  addresses,
  sellitems,
  sellitemMemberships,
  sellitemLabels,
  payments,
  attachments,
  actions,
  notifications,
  products,
  categories,
  productCategories,
  shipments,
  shiplines,
  product,
) => ({
  type: ActionTypes.SOCKET_RECONNECT_HANDLE,
  payload: {
    user,
    group,
    users,
    businesses,
    businessManagers,
    countries,
    brands,
    accounts,
    customerGroups,
    groups,
    groupMemberships,
    labels,
    customers,
    addresses,
    sellitems,
    sellitemMemberships,
    sellitemLabels,
    payments,
    attachments,
    actions,
    notifications,
    products,
    categories,
    productCategories,
    shipments,
    shiplines,
    product,
  },
});

handleSocketReconnect.fetchCore = (currentUserId, currentGroupId) => ({
  type: ActionTypes.SOCKET_RECONNECT_HANDLE__CORE_FETCH,
  payload: {
    currentUserId,
    currentGroupId,
  },
});
